<app-primary-button
  [title]="state().labelKey"
  [disable]="state().disabled"
  [loading]="state().loading"
  (action)="onAction()"></app-primary-button>
